import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["openTime", "closeTime"]

  connect() {
    this.updateTimeOptions()
  }

  updateTimeOptions() {
    const openSelect = this.openTimeTarget
    const closeSelect = this.closeTimeTarget
    
    openSelect.addEventListener('change', () => {
      const selectedTime = openSelect.value
      
      // Reset close time options
      Array.from(closeSelect.options).forEach(option => {
        option.disabled = option.value && option.value <= selectedTime
      })
      
      // If current close time is invalid, reset it
      if (closeSelect.value && closeSelect.value <= selectedTime) {
        closeSelect.value = ""
      }
    })

    closeSelect.addEventListener('change', () => {
      const selectedTime = closeSelect.value
      
      // Reset open time options
      Array.from(openSelect.options).forEach(option => {
        option.disabled = option.value && option.value >= selectedTime
      })
      
      // If current open time is invalid, reset it
      if (openSelect.value && openSelect.value >= selectedTime) {
        openSelect.value = ""
      }
    })
  }
} 